module.exports = __webpack_public_path__ + "img/circle16.8e0f42d2.png";